export default {"src":"/_next/static/media/business2.f043c418.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};